import { V3Record } from 'data/helpers/V3Record.js'

export const Gear = V3Record('gear', {
  archived: false,
  createdAt: null,
  description: null,
  highlightedPhotoId: null,
  name: null,
  userId: null
})
